import Model, { hasMany, attr } from '@ember-data/model';
import { buildValidations, validator } from '@eflexsystems/ember-tracked-validations';

@buildValidations({
  requiredQuantity: [
    validator('presence', true),

    validator('number', {
      gte: 0,
      integer: true,
      allowNone: false,
    }),
  ],
})
class BuildStatusMultipiece extends Model {
  @attr('string') multipieceId;
  @attr('number') requiredQuantity;
  @attr('number', { defaultValue: 0 }) completedQuantity;
  @attr('number', { defaultValue: 0 }) rejectedQuantity;
  @attr('number', { defaultValue: 0 }) scrappedQuantity;
  @attr('string') userId;
  @attr('string') userName;
  @attr('string') kineticEmployeeId;
  @attr('date') timestamp;
  @attr('date') createdAt;

  @hasMany('live-build-status', { async: false, inverse: 'buildStatusMultipiece' }) liveBuildStatuses;
  @hasMany('build-status', { async: false, inverse: 'buildStatusMultipiece' }) buildStatuses;
}

export default BuildStatusMultipiece;
